import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { SectionTitle } from '@cc-shopping/ui/composites/SectionTitle';
import { spacing } from '@cc-shopping/ui/theme';
import { Box } from '@mui/material';
import { tableOfContentsMap } from 'src/app/credit-cards/reviews/components/Body/TableOfContents/constants';
import MiniProductCard from 'src/app/credit-cards/reviews/components/Body/WordpressSections/HowToDecide/components/MiniProductCard';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import { StructuredContentRenderer } from 'src/features/content/StructuredContentRenderer';
export default function HowToDecide() {
  const {
    howToDecide
  } = useReviewContext();
  if (!howToDecide) {
    return null;
  }
  const BACKGROUND_MARGIN_Y = spacing(5);
  return <FeatureViewed entityName="accordion" entitySection="How To Decide If It's Right For You" impressionPosition={6}>
      <Box borderRadius={spacing(3)} sx={{
      position: 'relative',
      paddingY: BACKGROUND_MARGIN_Y,
      marginY: {
        xs: 0,
        sm: 3
      },
      maxWidth: '100%',
      '&:before': {
        content: '""',
        backgroundColor: 'greens.extraLight',
        position: 'absolute',
        height: '100%',
        marginTop: `-${BACKGROUND_MARGIN_Y}`,
        width: '100vw',
        left: {
          xs: 'calc(var(--padding-x) * -1)',
          lg: 'calc((((100vw - 1280px) / 2) + var(--padding-x)) * -1)'
        },
        zIndex: -1
      }
    }} id={tableOfContentsMap.HOW_TO_DECIDE.id}>
        <Box padding={spacing(3)} bgcolor="white" sx={theme => ({
        [theme.breakpoints.up('sm')]: {
          padding: 0
        },
        overflowWrap: 'break-word'
      })}>
          <Box display="flex" flexDirection="column">
            <SectionTitle icon={{
            iconNode: <Box component="span" aria-hidden="true" data-testid="section-title-icon" className="mask-icon mask-icon-balance" sx={{
              width: {
                xs: spacing(5),
                sm: spacing(3.5)
              },
              height: {
                xs: spacing(5),
                sm: spacing(3.5)
              },
              backgroundColor: '#008254',
              marginLeft: {
                xs: 0,
                sm: spacing(3)
              }
            }} />
          }} heading={{
            text: `How To Decide If It's Right For You`,
            customStyle: {
              lineHeight: spacing(4)
            }
          }} />
          </Box>
          <Box display="flex" flexDirection="column" gap={spacing(3)} sx={theme_0 => ({
          [theme_0.breakpoints.up('sm')]: {
            flexDirection: 'row',
            gap: spacing(4),
            padding: `0 ${spacing(4)}`,
            paddingBottom: spacing(4)
          }
        })}>
            <div data-testid="howToDecideSectionText">
              <StructuredContentRenderer doc={howToDecide} />
            </div>
            <MiniProductCard />
          </Box>
        </Box>
      </Box>
    </FeatureViewed>;
}